import { CreateCredentialsQueryArg } from '../types/query-arg';
import { CreateCredentialsQueryBody } from '../types/query-body';

export const createCredentialsQueryBody = ({
  username,
  password,
  type,
}: CreateCredentialsQueryArg): CreateCredentialsQueryBody => ({
  username,
  password,
  type,
});
